import { AxiosRequestConfig } from "axios";
import { Resource } from "./resource";

export class APIClient {
  private _endpoint!: URL;

  constructor(endpoint: string) {
    this.endpoint = new URL(endpoint);
  }

  get endpoint(): URL {
    return this._endpoint;
  }

  set endpoint(_endpoint: URL) {
    this._endpoint = _endpoint;
  }
  /**
   * Returns an AxiosRequestConfig object with Authentication headers
   *
   * TODO Implement authentication mechanisms
   */
  getXhrConfig = (): AxiosRequestConfig => {
    return {};
  };
  /**
   * Returns a new Resource with this client attached
   *
   * @typeparam T   Type of the resource
   * @typeparam K   Type of the constructor argument
   * @param ctor    Class of the resource to be created
   * @param data    Payload passed to the resource constructor
   *
   * @return Instance of the resource
   */
  createResource = <T extends Resource, K>(
    ctor: { new (client: APIClient, payload?: K): T },
    data?: K
  ): T => {
    return new ctor(this, data);
  };
}
